import React from 'react'
import '../../assets/css/PrintFactorComponent.css';


export const PrintFactorComponent = ({ foods }) => {
    const totalPrice = foods.reduce((sum, item) => sum + (item.price * item.count), 0);
    const totalCount = foods.reduce((sum, item) => sum + item.count, 0);
    return (
        <>
            <br />
            <div>
                <table className="factor-table">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>روز هفته</th>
                            <th>تاریخ</th>
                            <th>وعده غذایی</th>
                            <th>عنوان غذا</th>
                            <th>تعداد</th>
                            <th>فی (ریال)</th>
                            <th>قیمت کل (ریال)</th>
                            <th>توضیحات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {foods.map((food, index) => (
                            <tr key={food.id}>
                                <td>{index + 1}</td>
                                <td>{food.dayOfWeek}</td>
                                <td>{food.date_Shamsi}</td>
                                <td>{food.persionFoodSection}</td>
                                <td>{food.foodTitle}</td>
                                <td>{food.count}</td>
                                <td>{food.price.toLocaleString('fa-IR')}</td>
                                <td>{(food.price * food.count).toLocaleString('fa-IR')}</td>
                                <td></td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="4"></td>
                            <td>مجموع</td>
                            <td>{totalCount}</td>
                            <td>مبلغ کل</td>
                            <td>{totalPrice.toLocaleString('fa-IR')}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <br />
            <div className="table-container">
                <table className="food-table">
                    <thead>
                        <tr>
                            <th> امضا متقاضی</th>
                            <th>مهر و امضا مسئول امور مالی</th>
                            <th>مهر و امضا پذیرش</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td><br /><br /><br /></td>
                            <td><br /><br /><br /></td>
                            <td><br /><br /><br /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

